import PublicationCard from "../../components/publicationCard/publicationCard";
import AwardCard from "../../components/awardCard/AwardCard";

// import egamnet from "../../assets/publications/EGAMNet.png";
import yolo3d from "../../assets/publications/yolo3d.png";
import gamnet from "../../assets/publications/GAMNet.png";
// import stcgam from "../../assets/publications/STCGAM.png";

import newZealandFlag from "../../assets/flags/newZealand.png";
import thailandFlag from "../../assets/flags/thailand.png";
import koreaFlag from "../../assets/flags/southKorea.png";
import japanFlag from "../../assets/flags/japan.png";

import "./research.css";

export default function Publications() {
    return (

        <div className="research" id="research">
        
            <section className="publications-section">

                <div className="glitch_section" data-text="Publications">Publications</div>

                {/* <PublicationCard
                    title="STCGAM: Spatial-Temporal-Channel Graph Attention MLP for 3D Human Pose Estimation"
                    conference="2025 40th International Conference on Image and Vision Computing New Zealand (IVCNZ), December 19-20, 2025, Wellington, New Zealand"
                    countryFlag={japanFlag}
                    countryName="Japan"
                    image={stcgam}
                    imageAlt="STCGAM paper preview"
                    abstract="Graph convolutional networks (GCNs) and their variants have demonstrated considerable potential for 3D human pose estimation. Nevertheless, although they offer clear efficiency advantages, their accuracy still lags slightly behind that of recent transformer-based approaches. To narrow this gap, we propose STCGAM, a Spatial-Temporal-Channel Graph Attention MLP Network that unifies Multi Layer Perceptrons (MLPs) with graph convolutions and efficient temporal, spatial, and channel attention mechanisms. In STCGAM, MLPs are used to model global skeletal dependencies, whereas GCNs capture local skele- tal topology by adaptively refining the natural skeleton graph during training. Furthermore, an Efficient Temporal Attention module is introduced to extract temporal information from consecutive frames, an Efficient Channel Atten- tion block is employed to recalibrate feature responses across channels, and an Efficient Spatial Attention module is designed to emphasize salient joint inter- actions. Through this tri-branch design, the proposed architecture effectively captures local structural relationships, global contextual information, and tem- poral dynamics, while maintaining low computational complexity. Experimental results on Human3.6M, MPI-INF-3DHP, and HumanEva verify the effectiveness of the proposed approach. With only 13.73M parameters and 245 MFLOPs for 243-frame inputs, STCGAM achieves best performance among the compared graph-based methods and remains competitive with strong transformer-based models, while requiring substantially lower computational cost."
                    paperUrl=""
                    codeUrl=""
                    readMoreUrl=""
                    layout="reverse"
                /> */}

                {/* <PublicationCard
                    title="EGAMNet: Enhanced Graph Attention MLP Network for Efficient 3D Human Pose Estimation"
                    conference="23rd Advanced Concepts for Intelligent Vision Systems (ACIVS), December 15-17, 2026, Okinawa, Japan"
                    countryFlag={japanFlag}
                    countryName="Japan"
                    image={egamnet}
                    imageAlt="EGAMNet paper preview"
                    abstract="Graph convolutional networks provide an efficient way to model the human skeleton for 3D human pose estimation, but their ac- curacy often remains below that of recent transformer-based methods. This paper presents EGAMNet, an enhanced graph-attention MLP net- work designed as a graph-centered architecture for accurate and efficient 3D pose lifting. EGAMNet follows a branch-specific design composed of a Spatial Graph-Attention Branch and a Channel Graph-Attention Branch. The spatial branch integrates spatio-temporal graph convolu- tion with spatial feature mixing and efficient spatial attention to model anatomical dependencies and short-term motion cues, while the chan- nel branch uses graph-based channel refinement with efficient channel attention to preserve lightweight feature interaction. Experiments on Human3.6M and MPI-INF-3DHP show that EGAMNet improves the accuracy-efficiency trade-off among lightweight graph-based methods. In particular, EGAMNet achieves 43.1 mm MPJPE on Human3.6M while requiring only 172 MFLOPs and 0.21 ms inference time for 243-frame in- puts using a single RTX 3060 GPU. The results indicate that selectively applying spatio-temporal graph reasoning in the spatial branch improves pose estimation accuracy with only a small computational overhead."
                    paperUrl=""
                    codeUrl=""
                    readMoreUrl=""
                    layout="reverse"
                /> */}
                
                
                <PublicationCard
                    title="GAMNet: Graph Attention Mlp-Based Network for 3D Human Pose Estimation"
                    conference="40th International Conference on Image and Vision Computing New Zealand (IVCNZ), December 19-20, 2025, Wellington, New Zealand"
                    countryFlag={newZealandFlag}
                    countryName="New Zealand"
                    image={gamnet}
                    imageAlt="GAMNet paper preview"
                    abstract="Graph convolutional networks (GCNs) and their variants have shown significant promise in 3D human pose estimation, but despite their efficiency advantages they still lag slightly behind recent Transformer-based methods in accuracy. To bridge this gap, we propose GAMNet: an Efficient Graph Attention MLP-based Network that unifies adaptive graph convolutions with lightweight MLP blocks, augmented by efficient channel and spatial attention mechanisms. Specifically, GAMNet learns skeleton topology via an adaptive graph modules that refines the graph structure during training, recalibrates feature channels using an Efficient Channel Attention block to emphasize informative dimensions, and highlights salient joint interactions with a lightweight Spatial Attention. By integrating these components within a dual-branch GCN-MLP architecture, GAMNet effectively models both local skeletal connectivity and global contextual dependencies with minimal overhead. Extensive experiments on Human3.6M and MPI-INF-3DHP demonstrate that GAMNet requires only 8.97 M parameters and 157 MFLOPs for a 243 -frame input to surpass the accuracy of leading Graph-based methods and show competitive results compared with strong Transformer-based methods with lower computational cost."
                    paperUrl="https://ieeexplore.ieee.org/document/11281821"
                    codeUrl=""
                    readMoreUrl="https://ieeexplore.ieee.org/document/11281821"
                    layout="wide"
                />

                <PublicationCard
                    title="YOLOv5 with Mixed Backbone for Efficient Spatio-Temporal Hand Gesture Localization and Recognition"
                    conference="18th International Conference on Machine Vision Applications (MVA), July 23-25, 2023, Hamamatsu, Japan"
                    countryFlag={japanFlag}
                    countryName="Japan"
                    image={yolo3d}
                    imageAlt="YOLOv5 with Mixed Backbone paper preview"
                    abstract="Spatio-temporal Hand Gesture Localization and Recognition is an emerging topic due to the increasing popularity of hand movements for interaction with digital devices. This paper proposes an efficient approach for recognizing and localizing hand gestures from video sequences."
                    paperUrl="https://ieeexplore.ieee.org/document/10215605"
                    codeUrl=""
                    readMoreUrl="https://ieeexplore.ieee.org/document/10215605"
                    layout="reverse"
                />



            </section>

            <section className="awards-section">
                
                <div className="glitch_section" data-text="Awards">Awards</div>

                <AwardCard
                    title="MEXT Scholarship for Graduate Studies"
                    event="Japanese Government"
                    location="Tokyo, Japan"
                    year="2024 – 2027"
                    countryFlag={japanFlag}
                    countryName="Japan"
                />

                <AwardCard
                    title="Certificate of Participation"
                    event="International Workshop on Advanced Image Technology (IWAIT)"
                    location="Jeju, South Korea"
                    year="2023"
                    countryFlag={koreaFlag}
                    countryName="South Korea"
                />

                <AwardCard
                    title="Young Researchers Encouragement Award for the Best Project of the Conference"
                    event="The 5th ASEAN UEC Seminar on Informatics and Engineering"
                    location="Bangkok, Thailand"
                    year="2023"
                    countryFlag={thailandFlag}
                    countryName="Thailand"
                />

                <AwardCard
                    title="Certificate of Congratulations and Commendation for the Best Student of the Generation"
                    event="The University of Electro-Communications (電気通信大学)"
                    location="Tokyo, Japan"
                    year="2023"
                    countryFlag={japanFlag}
                    countryName="Japan"
                />

                <AwardCard
                    title="JASSO Scholarship for Exchange Students"
                    event="Japan Student Services Organization"
                    location="Tokyo, Japan"
                    year="2021 – 2022"
                    countryFlag={japanFlag}
                    countryName="Japan"
                />

            </section>
        </div>
    );
}